import { EmptyObservable } from './EmptyObservable';
export var empty = EmptyObservable.create;
//# sourceMappingURL=empty.js.map